/* MiniModalLoadingFallback.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDuMRm%7Bborder-radius%3Avar(--ds-radius-xxlarge%2C1pc)%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._0jFU0VIZbP%7Bheight%3Aauto%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._0GwItXFlnN%7Balign-content%3Astretch%7D%0A._0hPCNLFlnN%7Balign-items%3Astretch%7D%0A._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D%0A._3vBAKH9r67%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D%0A._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D%0A._3hxITi6wH8%7Bborder-style%3Asolid%7D%0A._3138425zaO%7Bmargin-top%3Avar(--ds-space-200%2C1pc)%7D%0A._2C2kUQ8fU6%7Bborder-top-left-radius%3Avar(--ds-radius-large%2C8px)%7D%0A._1Lz9lo8fU6%7Bborder-top-right-radius%3Avar(--ds-radius-large%2C8px)%7D");

















import React from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { MiniModalLoadingContent } from './MiniModalLoadingContent';
const styles = {
  wrapper: "_0bjKvDuMRm _4bt5LAnQyn _2WAcuGnQyn _24h04i2Njc _39xV02N91d _0jFU0VIZbP _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _0GwItXFlnN _0hPCNLFlnN _2OUyjtGk8v",
  wrapperNav3: "_3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _3138425zaO _2C2kUQ8fU6 _1Lz9lo8fU6"
};

// This shell loads before the assistant providers. Keep it independent of MainWrapper so
// the async entry point does not eagerly load the chat layout and session panels.
export const MiniModalLoadingFallback = ({
  topOffset,
  isNav4Enabled
}: {
  topOffset: number;
  isNav4Enabled: boolean;
}): JSX.Element => <Box data-rovo-chat-panel="true" xcss={cx(styles.wrapper, !isNav4Enabled && styles.wrapperNav3)} style={{
  width: isNav4Enabled ? undefined : `calc(100% - ${"var(--ds-space-150, 12px)"})`
}}>
		<MiniModalLoadingContent topOffset={topOffset} />
	</Box>;